export function fmtPct(v: number, decimals = 1): string {
  return `${(v * 100).toFixed(decimals)}%`;
}

export function fmtCI(lower: number, upper: number, decimals = 3): string {
  return `[${lower.toFixed(decimals)}, ${upper.toFixed(decimals)}]`;
}

export function fmtKm(km: number): string {
  return km >= 999 ? "None detected" : `${km.toFixed(1)} km`;
}

export function fmtDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric", month: "short", day: "numeric",
    });
  } catch {
    return iso;
  }
}
